// Updated to Vuetify 3 for Vue 3 compatibility
import { createVuetify } from 'vuetify'
import 'vuetify/styles' // Global CSS has to be imported

console.log('Vuetify plugin initializing...')

const vuetify = createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          // Core customizable colors
          primary: '#2E9F9E',
          secondary: '#dccbb6',
          accent: '#FF8659',
          background: '#F5F5F5',
          surface: '#FFFFFF',

          // Semantic colors (less commonly changed)
          error: '#ff6f6a',
          info: '#2196F3',
          success: '#4caf50',
          warning: '#FBC02D',

          // Custom UI colors
          cancelColor: '#424242',
          confirmColor: '#4caf50',
          dangerColor: '#ff6f6a',

          // Deprecated - kept for backward compatibility
          tertiary: '#FF8659'
        }
      },
      dark: {
        dark: true,
        colors: {
          // Core customizable colors
          primary: '#2E9F9E',
          secondary: '#5D4E37',
          accent: '#FF8659',
          background: '#121212',
          surface: '#1E1E1E',

          // Semantic colors
          error: '#cf6679',
          info: '#64B5F6',
          success: '#81c784',
          warning: '#FFD54F',

          // Custom UI colors
          cancelColor: '#757575',
          confirmColor: '#81c784',
          dangerColor: '#cf6679',

          // Deprecated - kept for backward compatibility
          tertiary: '#FF8659'
        }
      }
    }
  },

  // Global component defaults to keep styles consistent and make cross-site changes easy
  defaults: {
    // Make primary buttons tonal by default and consistent sizing
    VBtn: {
      // Use 'elevated' for a clearer, more clickable primary button appearance across the app
      variant: 'elevated',
      color: 'primary',
      size: 'default'
    },

    // Standardize text fields and inputs
    VTextField: {
      variant: 'outlined',
      density: 'comfortable'
    },

    // Keep cards consistent (rounded + no raised elevation by default)
    VCard: {
      rounded: 'lg',
      elevation: 0
    },

    // Note: We removed global `VCol` defaults in favor of semantic wrapper components
    // such as `AutoColLarge` and `AutoColSmall` which provide explicit, discoverable
    // column defaults for different use-cases. This prevents surprising layout changes
    // when a global default is changed and makes usage explicit in templates.
  }
})

console.log('Vuetify theme configuration:', vuetify.theme)

export default vuetify
